export enum TestIds {
  AppetiteType = 'appetiteType',
  Impact = 'impact',
  LikelihoodAppetite = 'likelihoodAppetite',
  LowerAppetite = 'lowerAppetite',
  UpperAppetite = 'upperAppetite',
}
